<template>
  <div class="customerOrderDetailPage">
    <el-tabs
      v-model="activeName"
      type="border-card"
      :before-leave="onBeforeLeave"
    >
      <el-tab-pane
        :label="$l('tech_detail_tab_pane_base_info') || '基本信息'"
        name="base"
      >
        <TechInfo
          ref="techInfo"
          :disabled="disabled"
          :techCode="params.techCode"
          :orderCode.sync="orderCode"
          :productLine.sync="productLine"
          :identifyGoodsName="params.identifyGoodsName"
          :orderGoodsSpecCode="params.orderGoodsSpecCode"
          :techGoodsSpecCode.sync="techGoodsSpecCode"
        />
        <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.techInfo.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tech_detail_tab_pane_product_info') || 'BOM信息'"
        name="dom"
        lazy
      >
        <!-- 工艺单产品 -->
        <TechGoods
          ref="techGoods"
          :techCode="params.techCode"
          :productLine="productLine"
          :techGoodsSpecCode="techGoodsSpecCode"
          :disabled="disabled"
        />
        <!-- 工艺单生产工序 -->
        <TechProcesses
          :disabled="disabled"
          class="mt-4"
          :techCode="params.techCode"
          :orderCode="orderCode"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tech_detail_tab_pane_proosess_sheet_doc') || '工艺单文档'"
        name="doc"
        lazy
      >
        <TechDoc
          ref="techDoc"
          :techCode="params.techCode"
          :orderCode="orderCode"
          :disabled="disabled"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import TechInfo from '../components/tech-info'
import TechGoods from '../components/tech-goods'
import TechDoc from '../components/tech-doc'
import TechProcesses from '../components/tech-processes'
export default {
  name: 'technology-processSheet-detail',
  components: { TechInfo, TechGoods, TechDoc, TechProcesses },
  data() {
    return {
      activeName: 'base',
      orderCode: '',
      productLine: '',
      techGoodsSpecCode: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    const { orderCode, productLine } = this.params
    if (orderCode) this.orderCode = orderCode
    if (productLine) this.productLine = productLine
  },
  methods: {
    onBeforeLeave(val) {
      if (val === 'base') {
        return true
      }
      if (!this.params.techCode || this.pageType === 'add') {
        this.$message.warning(
          this.$l('INDEX.tips_save_basicinfo_first') || '请先保存基本信息!'
        )
        return false
      }
    },
  },
}
</script>
